import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';

export const useIsStorageEnforcementEligible = (): boolean => {
	const { edition, isLoggedIn } = useSessionData();
	const isEligibleUser = edition === ConfluenceEdition.FREE && isLoggedIn;

	return isEligibleUser;
};
